(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[113],{

/***/ 3330:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projects/compress-create-react-app",
      function () {
        return __webpack_require__(7547);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3510);


var CompressCreateReactAppPage = function(param) {
    var content = param.content;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        title: "compress-create-react-app | Joonas Niemenjoki",
        language: "en",
        i18n: "https://niemenjoki.fi/projektit/compress-create-react-app",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "md",
            dangerouslySetInnerHTML: {
                __html: content
            }
        })
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (CompressCreateReactAppPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [976,948,913,510,774,888,179], function() { return __webpack_exec__(3330); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);